interface StyleObject {
  aside: string;
  asideScrollbars: string;
  asideBrand: string;
  asideMenuItem: string;
  asideMenuItemActive: string;
  asideMenuDropdown: string;
  navBarItemLabel: string;
  navBarItemLabelHover: string;
  navBarItemLabelActiveColor: string;
  overlay: string;
  activeLinkColor: string;
  bgLayoutColor: string;
  iconsColor: string;
  cardsColor: string;
  focusRingColor: string;
  corners: string;
  cardsStyle: string;
  linkColor: string;
  websiteHeder: string;
  borders: string;
  shadow: string;
  websiteSectionStyle: string;
  textSecondary: string;
}

export const white: StyleObject = {
  aside: 'bg-white text-slate-900 border-r border-slate-200 dark:text-white',
  asideScrollbars: 'aside-scrollbars-light',
  asideBrand: 'border-b border-slate-200',
  asideMenuItem:
    'text-slate-600 hover:bg-slate-100 hover:text-slate-950 dark:text-slate-300 dark:hover:text-white dark:hover:bg-dark-800',
  asideMenuItemActive: 'font-semibold text-slate-950 dark:text-white',
  asideMenuDropdown: 'bg-slate-50/80',
  navBarItemLabel: 'text-slate-600',
  navBarItemLabelHover: 'hover:text-slate-950',
  navBarItemLabelActiveColor: 'text-slate-950',
  overlay: 'from-white via-gray-100 to-white',
  activeLinkColor: 'bg-emerald-50 ring-1 ring-emerald-200',
  bgLayoutColor: 'bg-slate-50',
  iconsColor: 'text-emerald-700',
  cardsColor: 'bg-white',
  focusRingColor:
    'focus:ring focus:ring-emerald-100 focus:border-emerald-500 focus:outline-none border-slate-300 dark:focus:ring-emerald-800 dark:focus:border-emerald-500',
  corners: 'rounded-xl',
  cardsStyle: 'bg-white border border-slate-200 shadow-sm',
  linkColor: 'text-emerald-700',
  websiteHeder: 'border-b border-slate-200',
  borders: 'border-slate-200',
  shadow: 'shadow-sm',
  websiteSectionStyle: '',
  textSecondary: 'text-slate-500',
};

export const dataGridStyles = {
  '& .MuiDataGrid-cell': {
    paddingX: 3,
    border: 'none',
  },
  '& .MuiDataGrid-columnHeader': {
    paddingX: 3,
  },
  '& .MuiDataGrid-columnHeaderCheckbox': {
    paddingX: 0,
  },
  '& .MuiDataGrid-columnHeaders': {
    paddingY: 4,
    borderStartStartRadius: 7,
    borderStartEndRadius: 7,
  },
  '& .MuiDataGrid-footerContainer': {
    paddingY: 0.5,
    borderEndStartRadius: 7,
    borderEndEndRadius: 7,
  },
  '& .MuiDataGrid-root': {
    border: 'none',
  },
};

export const basic: StyleObject = {
  aside: 'bg-gray-800',
  asideScrollbars: 'aside-scrollbars-gray',
  asideBrand: 'bg-gray-900 text-white',
  asideMenuItem: 'text-gray-300 hover:text-white',
  asideMenuItemActive: 'font-bold text-white',
  asideMenuDropdown: 'bg-gray-700/50',
  navBarItemLabel: 'text-black',
  navBarItemLabelHover: 'hover:text-blue-500',
  navBarItemLabelActiveColor: 'text-blue-600',
  overlay: 'from-gray-700 via-gray-900 to-gray-700',
  activeLinkColor: 'bg-gray-100/70',
  bgLayoutColor: 'bg-gray-50',
  iconsColor: 'text-blue-500',
  cardsColor: 'bg-white',
  focusRingColor:
    'focus:ring focus:ring-blue-600 focus:border-blue-600 focus:outline-none dark:focus:ring-blue-600 border-gray-300 dark:focus:border-blue-600',
  corners: 'rounded',
  cardsStyle: 'bg-white border border-pavitra-400',
  linkColor: 'text-black',
  websiteHeder: '',
  borders: '',
  shadow: '',
  websiteSectionStyle: '',
  textSecondary: '',
};
